import { Component, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { format } from 'date-fns';
import { el } from 'date-fns/locale';

@Component({
  selector: 'app-auth-footer',
  templateUrl: './auth-footer.component.html',
  styleUrl: './auth-footer.component.scss'
})
export class AuthFooterComponent {
  @Input() appVersion: string = environment.appVersion;
  @Input() today = format(new Date(), 'iiii dd/MM/yyyy', { locale: el });
  @Input() currentYear = new Date().getFullYear();
}
